import $ from 'jquery'
import EventEmitter from 'eventemitter3'

export default function OverlayController (element, options) {
  const _this = this
  var _settings

  /* state */
  var animationTimer = null
  var eventEmitter = new EventEmitter()

  function construct () {
    _settings = $.extend(
      {
        overlayVisibleClass: 'page-overlay--visible',
        overlayInvisibleClass: 'page-overlay--invisible',
        bodyVisibleClass: 'page--overlay-visible',
        bodyInvisibleClass: 'page--overlay-visible',
        animationMs: 200,
        animationClass: 'page-overlay--animating'
      },
      options
    )

    _bindUIActions()
  }

  /* public */
  _this.show = () => {
    eventEmitter.emit('beforeshow')

    var $overlayElement = $(element)
    var $bodyElement = $(document.body)

    animation(() => {
      eventEmitter.emit('aftershow')
    })

    setTimeout(() => {
      if (_settings.bodyInvisibleClass) {
        $bodyElement.removeClass(_settings.bodyInvisibleClass)
      }
      if (_settings.overlayInvisibleClass) {
        $overlayElement.removeClass(_settings.overlayInvisibleClass)
      }
      if (_settings.bodyVisibleClass) {
        $bodyElement.addClass(_settings.bodyVisibleClass)
      }
      if (_settings.overlayVisibleClass) {
        $overlayElement.addClass(_settings.overlayVisibleClass)
      }
    }, 10)
  }

  /* public */
  _this.hide = () => {
    eventEmitter.emit('beforehide')

    var $overlayElement = $(element)
    var $bodyElement = $(document.body)

    if (_settings.bodyVisibleClass) {
      $bodyElement.removeClass(_settings.bodyVisibleClass)
    }
    if (_settings.overlayVisibleClass) {
      $overlayElement.removeClass(_settings.overlayVisibleClass)
    }
    if (_settings.bodyInvisibleClass) {
      $bodyElement.addClass(_settings.bodyInvisibleClass)
    }
    if (_settings.overlayInvisibleClass) {
      $overlayElement.addClass(_settings.overlayInvisibleClass)
    }

    animation(() => {
      eventEmitter.emit('afterhide')
    })
  }

  function animation (onReady) {
    var $overlayElement = $(element)
    $overlayElement.addClass(_settings.animationClass)
    if (animationTimer) {
      clearTimeout(animationTimer)
    }
    animationTimer = setTimeout(() => {
      $overlayElement.removeClass(_settings.animationClass)
      if (onReady) {
        onReady()
      }
    }, _settings.animationMs + 10)
  }

  this.isShown = function () {
    if (_settings.overlayVisibleClass) {
      var $overlayElement = $(element)
      return $overlayElement.hasClass(_settings.overlayVisibleClass)
    } else if (_settings.bodyVisibleClass) {
      var $bodyElement = $(document.body)
      return $bodyElement.hasClass(_settings.bodyVisibleClass)
    }
    return null
  }

  this.on = function (eventName, callback) {
    eventEmitter.on(eventName, callback)
  }

  this.once = function (eventName, callback) {
    eventEmitter.once(eventName, callback)
  }

  this.removeListener = function (eventName, callback) {
    eventEmitter.removeListener(eventName, callback)
  }

  /* private */
  function _bindUIActions () {
    // const closeButtonElement = _getCloseButtonElement();
    // if (closeButtonElement) {
    //   $(_getCloseButtonElement()).click(() => {
    //     _this.hide();
    //     return false;
    //   });
    // }
    // const openButtonElement = _getOpenButtonElement();
    // if (openButtonElement) {
    //   $(_getOpenButtonElement()).click(() => {
    //     _this.show();
    //     return false;
    //   });
    // }
  }

  construct()
}
